module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "pt",
    staticClass: "pt"
  }, [_c('div', {
    staticClass: "pt-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cp-ballType border-1px"
  }, [_c('div', {
    staticClass: "cp-box"
  }, _vm._l((_vm.redBall), function(item, index) {
    return _c('div', {
      staticClass: "ballItem"
    }, [_c('span', {
      staticClass: "ball whiteBall1",
      class: {
        redBall: item
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectRed(index, $event)
        }
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "cp-ballType"
  }, [_c('div', {
    staticClass: "cp-box"
  }, _vm._l((_vm.blueBall), function(item, index) {
    return _c('div', {
      staticClass: "ballItem"
    }, [_c('span', {
      staticClass: "ball whiteBall2",
      class: {
        blueBall: item
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectBlue(index, $event)
        }
      }
    }, [_vm._v(_vm._s(index + 1))])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_vm._v("至少选择6个红球1个篮球"), _c('span', {
    staticClass: "icon-shark"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d50943a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ssc/component/pt.vue
// module id = 71
// module chunks = 0